import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResourceHeader } from '../../models/resource-headers/resource-header.model';
import { ResourcePageService } from '../../services/resource-page.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'safetydirector-industry-resource-page',
  templateUrl: './industry-resource-page.component.html',
  styleUrls: ['./industry-resource-page.component.css']
})
export class IndustryResourcePageComponent {
  private BusyA;
  public searchString: string | null = null;
  public industry: string | null = null;
  public header: ResourceHeader;
  public pageName = 'Industry Resources';

  constructor(private resourcePageService: ResourcePageService, private activatedRoute: ActivatedRoute,
    private titleService: Title) {
  
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap
      .subscribe(params => {
        this.industry = params.get('industry')!;
        this.titleService.setTitle('Safety Director | ' + this.industry);
        this._getResourcePageHeader();
      });    
  }

  private _getResourcePageHeader() {
    this.BusyA = this
      .resourcePageService
      .getResourceHeader(this.industry!)
      .subscribe(result => {
        this.header = result[0];
      });
  }

  ngOnDestroy(): void {
    if (this.BusyA) {
      this.BusyA.unsubscribe();
    }
  }

  public filterResources(clearSearch = false) {
    if (clearSearch) {
      this.searchString = '';
    }
  }
}
